import { ButtonGroupProps } from 'react-multi-carousel';
import styled from 'styled-components';
import { rem } from 'polished';

import ArrowsButtonGroup from '../../Carousel/ArrowsButtonGroup';

const Container = styled.div`
    position: absolute;
    bottom: 20px;
    left: 50%;
    width: ${rem(210)};
`;

export const ButtonGroup = (props: ButtonGroupProps) => {
    return (
        <Container className="carousel-button-group">
            <ArrowsButtonGroup {...props} />
        </Container>
    );
};
